import { AiOutlineLoading3Quarters } from "react-icons/ai";
function Spinner() {
  return (
    <div className="w-full h-[50vh] grid place-content-center">
      <AiOutlineLoading3Quarters  className="w-16 h-16 fill-blue-400 animate-spin"/>
    </div>
  );
}
export default Spinner;